<div class="app-shell">
    <!-- Show navbar only when authenticated -->
    <app-nav-bar *ngIf="auth.isAuthenticated$ | async"></app-nav-bar>

    <!-- Show content directly -->
    <div class="app-content">
        <router-outlet></router-outlet>
    </div>

    <!-- Toast notifications -->
    <app-toast></app-toast>
</div>